interface LocationSelectorProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Array<{ id: string; name: string }>;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
}

export function LocationSelector({
  label,
  value,
  onChange,
  options,
  error,
  disabled,
  placeholder,
}: LocationSelectorProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-md text-black">{label}</label>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`w-full px-3 py-2 rounded-md border border-gray-300
          bg-white text-gray-700
          focus:outline-none focus:ring-2 ring-primary focus:border-primary focus:border-transparent
          disabled:bg-gray-100 disabled:cursor-not-allowed
          ${error ? "border-red-500 focus:ring-red-500" : ""}`}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
      {error && <span className="text-sm text-red-500">{error}</span>}
    </div>
  );
}
